import { render } from "./Mesas.vue?vue&type=template&id=871f3b64&scoped=true"
import script from "./Mesas.vue?vue&type=script&lang=js"
export * from "./Mesas.vue?vue&type=script&lang=js"

import "./Mesas.vue?vue&type=style&index=0&id=871f3b64&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871f3b64"]])

export default __exports__